export default "__VITE_ASSET__BRb3iXUn__"